import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators  } from '@angular/forms';
import { matchOtherValidator } from '../../shared/matchpass/matchpass';
import { AuthService } from '../../shared/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Logging } from '../../logging';
import { ApiService } from '../../shared/api-service/api.service';
import { HelpersService } from '../../shared/helpers/helpers.service';
declare var jquery:any;
declare var $ :any;
declare var App:any;


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  constructor(private api: ApiService,
              private auth: AuthService,
              private route: ActivatedRoute,
              private router: Router,private helpers: HelpersService,) { 


  }

  registerForm:  FormGroup;
  showErrors:boolean = false;
  loading: Boolean = false;
  hasError: Boolean = false;
  errorMessage: string ;
  referralcode:any;



  ngOnInit() {


    //Get the referral code if set
    this.route.params.subscribe(params => {
      
      if(params['referralcode']){
        this.referralcode = params['referralcode'];
      }
       
    });

    var url = window.location.origin+this.router.createUrlTree(['account-activation']).toString();
        Logging.log(url);

    this.registerForm = new FormGroup({
      name: new FormControl('',[Validators.required,
        Validators.pattern("[a-zA-Z0-9 \-]*"),
        Validators.minLength(5)]),
      iscompany: new FormControl(false,Validators.required),
      email: new FormControl('',[ 
          Validators.required, 
          Validators.email,
          Validators.pattern("[a-zA-Z0-9.@_]*")
        ]),
      phone: new FormControl('', [Validators.required,
        Validators.pattern("[0-9]*"),
         Validators.minLength(10), 
        Validators.maxLength(12)]),

      password: new FormControl('', [
          Validators.minLength(6), 
          Validators.required
        ]),
      repeatPassword: new FormControl('', [
         Validators.required,
         Validators.minLength(6),
          matchOtherValidator('password')
        ]),
    });


    //Navigate to dashboard after login success with this observable
    this.auth.token_set.subscribe((status) => {
      if(status == true){
        this.router.navigate(['/dashboard']);
      }
    });



  }

  userExist:boolean = false;

  checkEmail(email:string){

    if(this.registerForm.controls.email.valid){
      const body = {
        email: email,
      };
  
      this.api.post('/users/checkemail', body)
        .subscribe(
          res_data => {
          Logging.log(res_data);

          //Check if there was a success response with an existing user
          if(res_data.status == "SUCCESS"){
            //Check if there was an existing user returned
            if(res_data.data[0].status == true){
              this.userExist = true;
            }

          }

          }, error_message => {
            
            Logging.log('error');
          }
        );
    }
    
  }


  phoneExist:boolean = false;
  checkPhone(phone:string)
  {
    if(this.registerForm.controls.phone.valid){
      const body = {
        phonenumber: phone,
      };
  
      this.api.post('/users/checkphonenumber', body)
        .subscribe(
          res_data => {
          Logging.log(res_data);
          
          if(res_data.status == "SUCCESS"){
            if(res_data.data[0].status == true){
              this.phoneExist = true;
            }

          }

          }, error_message => {
            
            Logging.log('error');
          }
        );
    }
  }

  clearUserCheck(){
    this.userExist = false;
  }

  clearPhoneCheck(){
    this.phoneExist = false;
  }

  

  onSubmit(){
    
    if(this.userExist || this.phoneExist)
    {
      this.hasError = true;
      this.errorMessage = "Errors on page. Please correct page errors";
      //this.helpers.flashSuccess("");
      return;
    }

    this.loading = true;
    this.hasError = false;
    
    if(this.registerForm.valid){
      Logging.log(this.registerForm.value);

      // Convert Form values into json 
      const formValues = JSON.parse(JSON.stringify(this.registerForm.value));

      //Construct the phone number
      //Remove 0 chr from the phone if present
      if(formValues.phone.startsWith('0')){
        formValues.phone = formValues.phone.replace("0","");
      }

      formValues.mobilenumber = $('.selected-dial-code').text().replace("+", "") + formValues.phone;


      //Set Profile ID to Customer Profile ID
      // formValues.profileid = 6;

      // var url = window.location.origin+this.router.createUrlTree(['account-activation']).toString();
      //   Logging.log(url);

      // formValues.emailvalidationurl = url;
      

      Logging.log(formValues);
     
      //Register the current user
      this.api.post('/users/register', formValues)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);

        //Take the user to the login page to manually login
        this.router.navigate(['/login']);
          
        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );

    }else{
      //Set loading to true to show loader
      this.loading = false;
      //this.hasError = true;

      this.showErrors = true;
      Logging.log('Has Errors', this.registerForm.value);
      const formValues = JSON.parse(JSON.stringify(this.registerForm.value));

      // formValues.name = formValues.name.firstName + ' ' + formValues.name.lastName;
      formValues.phone = $('.selected-dial-code').text().replace("+", "") + formValues.phone;

      Logging.log(formValues);
    }
  }


  clearErrors(){
    this.hasError = false;
  }

  

}



// WEBPACK FOOTER //
// ./src/app/client/register/register.component.ts